import { Spacing, Text } from '@vkontakte/vkui';
import React, { memo, useCallback } from 'react';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { renderFullScreenAiPhotoGeneration } from 'reactApp/ui/AiPhotoGeneration/Modals/MainScreen/FullScreenAiPhotoGenerationModal.helpers';
import { sendXray } from 'reactApp/utils/ga';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './AiPhotoGenerationEntryPointModal.css';

interface Props {
    close?: () => void;
    complete?: () => void;
}

const name = 'ai-gen-entry-point-modal';

const modal_type = 'entry-point';

const AiPhotoGenerationEntryPointModal = memo(function AiPhotoGenerationPromoModal({ close, complete }: Props) {
    const handleDismiss = useCallback(() => {
        sendXray([name, 'close']);

        sendPaymentGa({
            eventCategory: ECategoryGa.aiPhotoGeneration,
            action: 'modal-close',
            modal_type,
            dwh_enabled: true,
            dwh_enabled_fields: [['modal_type']],
        });

        close?.();
    }, [close]);

    const handleShow = useCallback(() => {
        sendXray([name, 'show']);

        sendPaymentGa({
            eventCategory: ECategoryGa.aiPhotoGeneration,
            action: 'modal-show',
            modal_type,
            dwh_enabled: true,
            dwh_enabled_fields: [['modal_type']],
        });
    }, []);

    const handleClick = useCallback(() => {
        sendXray([name, 'click']);

        sendPaymentGa({
            eventCategory: ECategoryGa.aiPhotoGeneration,
            action: 'modal-click',
            modal_type,
            action_type: 'success',
            dwh_enabled: true,
            dwh_enabled_fields: [['modal_type']],
        });

        complete?.();
        renderFullScreenAiPhotoGeneration();
    }, [complete]);

    return (
        <WhatsNewDialog
            imageUrl={`${cdnPackagesUrl}/static/cloud/promo/aiPhotoGeneration/home/modal.webp`}
            imageWrapperClassName={styles.imageWrapper}
            closeIconClassName={styles.closeIcon}
            contentClassName={styles.content}
            title="Новое. Нейросеть создаст изображение по запросу"
            content={
                <>
                    <Spacing size={16} />
                    <Text data-qa-id="text">
                        Выбирайте стиль: от&nbsp;картины маслом до&nbsp;киберпанка. Без&nbsp;подписки у&nbsp;вас&nbsp;будет одна генерация
                        в&nbsp;день, а&nbsp;с&nbsp;Mail&nbsp;Space&nbsp;— 20&nbsp;в&nbsp;день
                    </Text>
                    <Spacing size={32} />
                </>
            }
            primaryButtonText="Попробовать"
            closeAfterClick
            onClick={handleClick}
            onShow={handleShow}
            onDismiss={handleDismiss}
            imageBgColor="var(--vkui--color_background_modal)"
            buttonTheme="vk"
            dialogSize="small"
            qaId="ai-photo-generation-promo-modal"
            isRebranding
        />
    );
});

AiPhotoGenerationEntryPointModal.displayName = 'AiPhotoGenerationPromoModal';

export default AiPhotoGenerationEntryPointModal;
